export const COLORS_TOTAL = 7

export const COLOR_METHOD_OPTIONS = [
  { text: 'auto', listText: 'auto', value: '*' },
  { text: 'monochromatic', listText: 'monochromatic', value: 'monochromatic' },
  { text: 'complementary', listText: 'complementary', value: 'complementary' },
  { text: 'color zebra', listText: 'color zebra', value: 'split_complementary' },
  { text: 'rainbow', listText: 'rainbow', value: 'analogous' },
  { text: 'analogous', listText: 'analogous', value: 'analogous_random' }
  // { text: 'triadic', listText: 'triadic (modified)', value: 'triadic' },
  // { text: 'tetradic', listText: 'tetradic (modified)', value: 'tetradic' },
  // { text: 'hue', listText: 'hue', value: 'analogous_hue' },
]

// The report's colour themes live in the shared colour lib -- the word-cloud presets name them
// by number and must resolve the same table. Re-exported so this panel's own imports read as before.
export { COLOR_THEMES } from '@aytm/app/stats/lib/render/colors'

export const DEFAULT_PALETTE = {
  colors: ['#CCCCCC', '#B2B2B2', '#999999', '#808080', '#666666', '#4D4D4D', '#333333'],
  saturation: 10,
  luminosity: 15
}
